function appendLinkToParagraph(paragraph, link) {
  var index = paragraph.lastIndexOf("</p>");

  return paragraph.slice(0, index) + paragraph.slice(index).replace("</p>", `&nbsp;<a class="post-continuation-link" href=${link}>Continue Reading →</a></p>`);
}

export default appendLinkToParagraph